import React from 'react'
import { Container } from 'react-bootstrap'
import { LiaGreaterThanSolid } from 'react-icons/lia'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import Otherheader from '../Header/Otherheader'
import './Sitemap.css'

const Sitemap = () => {
  const sections = [
    {
      title: 'Main Pages',
      links: [
        { to: '/', label: 'Home' },
        { to: '/about', label: 'About Us' },
        { to: '/doctor', label: 'Our Doctors' },
        { to: '/gallery', label: 'Gallery' },
        { to: '/award', label: 'Awards' },
        { to: '/blog', label: 'Blog' },
        { to: '/contact', label: 'Contact Us' },
        { to: '/appoint', label: 'Book an Appointment' },
        { to: '/medical-tourism', label: 'Medical Tourism' },
        { to: '/privacy', label: 'Privacy Policy' },
      ],
    },
    {
      title: 'Blog Articles',
      links: [
        { to: '/blog/best-laser-hair-reduction-treatment', label: 'Best Laser Hair Reduction Treatment' },
        { to: '/blog/pigmentation-treatment-causes-types-options', label: 'Pigmentation Treatment: Causes, Types & Options' },
        { to: '/blog/acne-treatment-when-to-see-a-dermatologist', label: 'Acne Treatment: When to See a Dermatologist' },
        { to: '/blog/chemical-peels-benefits-procedure-aftercare', label: 'Chemical Peels: Benefits, Procedure & Aftercare' },
        { to: '/blog/hydrafacial-benefits-who-should-consider', label: 'HydraFacial: Benefits and Who Should Consider It' },
        { to: '/blog/hair-fall-treatment-causes-and-solutions', label: 'Hair Fall Treatment: Causes and Solutions' },
        { to: '/blog/dandruff-vs-dry-scalp-difference', label: "Dandruff vs Dry Scalp: What's the Difference" },
        { to: '/blog/acne-scars-why-they-happen-and-treatment', label: 'Acne Scars: Why They Happen & Treatment' },
        { to: '/blog/skin-rejuvenation-treatment-options', label: 'Skin Rejuvenation Treatment Options' },
        { to: '/blog/how-to-choose-right-dermatological-treatment', label: 'How to Choose the Right Dermatological Treatment' },
      ],
    },
    {
      title: 'Dermatology & Cosmetic Services',
      links: [
        { to: '/drSweta/AWI', label: 'Anti Wrinkle Injection' },
        { to: '/drSweta/dermal', label: 'Dermal Fillers' },
        { to: '/drSweta/boosters', label: 'Skin Boosters' },
        { to: '/drSweta/hydrofacial', label: 'HydraFacial' },
        { to: '/drSweta/peels', label: 'Chemical Peels' },
        { to: '/drSweta/meso', label: 'Mesotherapy' },
        { to: '/drSweta/resurfacing', label: 'Skin Resurfacing' },
        { to: '/drSweta/laser', label: 'Laser Hair Reduction' },
        { to: '/drSweta/regrowth', label: 'Hair Regrowth Treatment' },
        { to: '/drSweta/micro', label: 'Microneedling' },
        { to: '/drSweta/makeup', label: 'Permanent Makeup' },
        { to: '/drSweta/facelift', label: 'Facelift' },
        { to: '/drSweta/eyelid', label: 'Eyelid Surgery' },
        { to: '/drSweta/necklift', label: 'Neck Lift' },
        { to: '/drSweta/browlift', label: 'Brow Lift' },
        { to: '/drSweta/chin', label: 'Chin Augmentation' },
        { to: '/drSweta/lip', label: 'Lip Augmentation' },
        { to: '/drSweta/transplant', label: 'Hair Transplant' },
        { to: '/drSweta/dimple', label: 'Dimple Creation' },
        { to: '/drSweta/earlube', label: 'Earlobe Repair' },
        { to: '/drSweta/grafting', label: 'Hair Grafting' },
        { to: '/drSweta/otoplasty', label: 'Otoplasty' },
        { to: '/drSweta/cheeks', label: 'Cheek Augmentation' },
        { to: '/drSweta/microneeding', label: 'Skin Microneedling' },
        { to: '/drSweta/pigmentation', label: 'Pigmentation Treatment' },
        { to: '/drSweta/rejuvention', label: 'Skin Rejuvenation' },
        { to: '/drSweta/tattoo', label: 'Tattoo Removal' },
        { to: '/drSweta/thread', label: 'Thread Lift' },
        { to: '/drSweta/liquid', label: 'Liquid Facelift' },
        { to: '/drSweta/carbon', label: 'Carbon Laser Peel' },
      ],
    },
    {
      title: 'Pulmonology & Diabetes Care (Dr. Gaurav Pandey)',
      links: [
        { to: '/drgaurav/asthma', label: 'Asthma Treatment' },
        { to: '/drgaurav/copd', label: 'COPD Treatment' },
        { to: '/drgaurav/allergies', label: 'Allergy Treatment' },
        { to: '/drgaurav/tb', label: 'Tuberculosis (TB) Treatment' },
        { to: '/drgaurav/cough', label: 'Chronic Cough Treatment' },
        { to: '/drgaurav/chest', label: 'Chest Infection Treatment' },
        { to: '/drgaurav/snoring', label: 'Snoring Treatment' },
        { to: '/drgaurav/sleep', label: 'Sleep Apnea Treatment' },
        { to: '/drgaurav/respiratory', label: 'Respiratory Disorders' },
        { to: '/drgaurav/sinusitis', label: 'Sinusitis Treatment' },
        { to: '/drgaurav/eosinophilia', label: 'Eosinophilia Treatment' },
        { to: '/drgaurav/diabetes', label: 'Diabetes Management' },
        { to: '/drgaurav/neuropathy', label: 'Diabetic Neuropathy' },
        { to: '/drgaurav/hypertension', label: 'Hypertension Management' },
        { to: '/drgaurav/ecg', label: 'ECG Testing' },
        { to: '/drgaurav/pft', label: 'Pulmonary Function Test (PFT)' },
        { to: '/drgaurav/sugar', label: 'Blood Sugar Testing' },
      ],
    },
    {
      title: 'Popular Standalone Service Pages',
      links: [
        { to: '/asthma', label: 'Asthma' },
        { to: '/weight-loss', label: 'Weight Loss' },
        { to: '/allergy', label: 'Allergy' },
        { to: '/glutathione', label: 'Glutathione Therapy' },
        { to: '/laser-hair-reduction', label: 'Laser Hair Reduction' },
        { to: '/acne', label: 'Acne Treatment' },
        { to: '/hair-transplant', label: 'Hair Transplant' },
        { to: '/filler', label: 'Dermal Fillers' },
        { to: '/thread', label: 'Thread Lift' },
        { to: '/anti-aging-treatment', label: 'Anti-Aging Treatment' },
        { to: '/microneedling', label: 'Microneedling' },
        { to: '/chemical-peel', label: 'Chemical Peel' },
      ],
    },
    {
      title: 'Location-Specific Treatment Pages',
      links: [
        { to: '/treatment/acne-rohini', label: 'Acne Treatment in Rohini' },
        { to: '/treatment/laser-hair-removal-rohini', label: 'Laser Hair Removal in Rohini' },
        { to: '/treatment/laser-hair-removal-shalimar-bagh', label: 'Laser Hair Removal in Shalimar Bagh' },
        { to: '/treatment/laser-hair-removal-pitampura', label: 'Laser Hair Removal in Pitampura' },
        { to: '/treatment/laser-hair-removal-punjabi-bagh', label: 'Laser Hair Removal in Punjabi Bagh' },
        { to: '/treatment/dermal-filler-rohini', label: 'Dermal Filler in Rohini' },
        { to: '/treatment/dermal-filler-shalimar-bagh', label: 'Dermal Filler in Shalimar Bagh' },
        { to: '/treatment/dermal-filler-punjabi-bagh', label: 'Dermal Filler in Punjabi Bagh' },
        { to: '/treatment/pigmentation-rohini', label: 'Pigmentation Treatment in Rohini' },
      ],
    },
  ]

  return (
    <>
      <Otherheader />
      <Helmet>
        <title>Sitemap – Sharva Clinique</title>
        <meta
          name='description'
          content='Browse the full sitemap of Sharva Clinique – find all our services, doctors, treatments, and pages in one place.'
        />
      </Helmet>

      <div className='sitemap_banner'>
        <Container>
          <div className='appoint_left'>
            <p className='lets'>
              Home <LiaGreaterThanSolid className='lets_icon' /> Sitemap
            </p>
          </div>
          <div className='gallery_head text-white'>
            <h2 className='pt-5'>Sitemap</h2>
            <p className='pt-2'>Find every page, service, and treatment offered at Sharva Clinique.</p>
          </div>
        </Container>
      </div>

      <Container className='sitemap_content my-5'>
        {sections.map((section) => (
          <div className='sitemap_section mb-5' key={section.title}>
            <h3 className='sitemap_heading pb-3'>{section.title}</h3>
            <ul className='sitemap_list'>
              {section.links.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </Container>
    </>
  )
}

export default Sitemap
